import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

export const CORE_ASSET_FIELDS = `
  id
  year
  make
  model
  name
  vin
  lastSix
  stockNumber
  clientNumber
  condition
  category
  status
  miles
  subCategory
  engineMfr
  engineType
  transmission
  listPrice
  axle
  sleeper
  suspension
  horsepower
  ratio
  wheelsRear
  wheelsFront
  wheelBase
  color
  mechanicalCondition
  expectedYieldPrice
  inspectionUrl
  notes
  street
  city
  state
  postalCode { formatted, value }
  acquired
  createdAt
  updatedAt
  soarrPhotoUrls
  cachedTitleStatus
  sellerNotes
`;

const ASSET_FIELDS = `
  ${CORE_ASSET_FIELDS}
  sellerFeesTotal
  soldSaleAsset {
    id
    sellerNet
    sellerAchOn
  }
  location {
    street
    city
    state
    postalCode { formatted, value }
    phoneNumber { formatted, value }
  }
  photos {
    id
    filename
    contentType
    url
  }
  latestTitleLog {
    id
  }
  seller {
    clientNumberLabel
    clientNumberLabelFull
  }
  titleLogs {
    id
    status
    notes
    upload { id, filename, contentType, url}
    titleNumber
    state
    latestUpload { url }
  }
  status
  buyer { id, name, street, city, state, postalCode { formatted } }
  soldOn
  soldAmount
  assetSellerUsers {
    id
    name
    sellerUser {id, fullName}
  }
  sellerDocuments {
    id
    filename
    contentType
    url
  }
  sellerDocumentNotes { id, attachmentId, body }
`;

export const ASSETS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    assetsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${ASSET_FIELDS}
      }
      count
    }
  }
`;

export const ASSET = gql`
  query Asset($id: ID!) {
    asset(id: $id) {
      ${ASSET_FIELDS}
    }
  }
`;

export const UPCOMING_SALE_ASSETS = gql`
  query UpcomingSaleAssets {
    upcomingSaleAssets {
      id
      lotNumber
      sale { id, saleOn }
      asset {
        ${CORE_ASSET_FIELDS}
        seller { id }
        photos { id, url }
      }
    }
  }
`;

const ASSET_VARIABLES = `
  $clientNumber: String
  $sellerUserIds: [ID!]
  $sellerNotes: String
`;

const ASSET_ARGUMENTS = `
  clientNumber: $clientNumber
  sellerUserIds: $sellerUserIds
  sellerNotes: $sellerNotes
`;

const ASSET_FIELDS_AND_ERRORS = `
  asset {
    ${ASSET_FIELDS}
  }
  ${ERRORS}
`;

export const CREATE_ASSET = gql`
  mutation CreateAsset(
    $sellerId: ID!
    $year: Int!
    $make: String!
    $model: String!
    $vin: String
    $sellerDocuments: [Upload!]
    $sellerDocumentNotes: [String!]
    ${ASSET_VARIABLES}
  ) {
    createAsset(
      sellerId: $sellerId
      year: $year
      make: $make
      model: $model
      vin: $vin
      sellerDocuments: $sellerDocuments
      sellerDocumentNotes: $sellerDocumentNotes
      ${ASSET_ARGUMENTS}
    ) {
      ${ASSET_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_ASSET = gql`
  mutation UpdateAsset(
    $id: ID!
    ${ASSET_VARIABLES}
    $sellerDocuments: [Upload!]
    $sellerDocumentNotes: [String!]
  ) {
    updateAsset(
      id: $id
      ${ASSET_ARGUMENTS}
      sellerDocuments: $sellerDocuments
      sellerDocumentNotes: $sellerDocumentNotes
    ) {
      ${ASSET_FIELDS_AND_ERRORS}
    }
  }
`;

export const SELLER_USER_SELECT_OPTIONS = gql`
  query NoUserLogSelectOptions {
    sellerUsers(scopes: ["notifications"]) {
      id
      fullName
    }
  }
`;

export const EXISTING_ASSETS = gql`
  query Assets {
    assets {
      vin
      name
      seller { id, name }
    }
  }
`;
